import React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";
import { TRANSACTION_TYPE_PAYMENT, TRANSACTION_TYPE_PAYOUT, TRANSACTION_TYPES } from "../../../utils/consts";

const SecondaryTransactionTypeSelect = ({ checkedType, setCheckedType, defaultOption = false, direction = null }) => {
  const { t } = useTranslation("otherInterface");

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedType(data);
  };

  const transactionTypes = direction === "payments"
    ? TRANSACTION_TYPE_PAYMENT
    : direction === "payouts"
      ? TRANSACTION_TYPE_PAYOUT
      : TRANSACTION_TYPES;

  return (
    <FormControl>
      <InputLabel id="demo-simple-select-label">{t("secondaryTransactionType.title")}</InputLabel>
      {/* No need to change on Autocomplete component (few options) */}
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={checkedType}
        onChange={handleChangeSelect}
      >
        {defaultOption && <MenuItem value={null}>{t("secondaryTransactionType.all")}</MenuItem>}
        {Object.entries(transactionTypes).map(([key, value]) => (
          <MenuItem key={key} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SecondaryTransactionTypeSelect;